import React, { ReactNode } from 'react';

import ContactHelper from '../../core/libs/ContactHelper';
import { ThirdPartyIcon, openUrl, ThirdPartyName } from '../../core/libs/utils';
import {
  ThirdPartyIdText,
  ViewContactCaption,
  ViewContactField,
  ViewContactThirdPartyIcon
} from '../styled/ContactsForm';

import { TAppContact, TAppThirdPartyId } from 'TProtocol/common/models';

export default function ProfessionalInfo(props: { contact: TAppContact }) {
  const email = props.contact.professionalEmail?.displayEmail ?? props.contact.professionalEmail?.emailAddress;
  const addressString = props.contact.professionalAddress && ContactHelper.addressString(props.contact.professionalAddress);
  let addressLink: ReactNode = null;
  if (addressString) {
    addressLink = <a target="google-maps" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      addressString)}`}>{addressString}</a>;
  }

  return (
    <div className="mb-2">
      {props.contact.primaryProfessionalInfo?.jobTitle &&
        <ViewContactField>
          <span>{props.contact.primaryProfessionalInfo.jobTitle}</span>
        </ViewContactField>
      }
      {props.contact.primaryProfessionalInfo?.companyName &&
        <ViewContactField>
          <span>{props.contact.primaryProfessionalInfo.companyName}</span>
        </ViewContactField>
      }
      {email &&
        <ViewContactField>
          <a href={`mailto: ${email}`}>{email}</a>
        </ViewContactField>
      }
      {props.contact.professionalMobile?.displayNumber &&
        <ViewContactField>
          <span>{props.contact.professionalMobile.displayNumber}</span>
          {props.contact.professionalMobile.label ?
            <ViewContactCaption>{props.contact.professionalMobile.label}</ViewContactCaption> :
            <ViewContactCaption>Mobile</ViewContactCaption>
          }
        </ViewContactField>
      }
      {props.contact.professionalLandline?.displayNumber &&
        <ViewContactField>
          <span>{props.contact.professionalLandline.displayNumber}</span>
          {props.contact.professionalLandline.label ?
            <ViewContactCaption>{props.contact.professionalLandline.label}</ViewContactCaption> :
            <ViewContactCaption>Landline</ViewContactCaption>
          }
        </ViewContactField>
      }
      {props.contact.professionalAddress?.address1 &&
        <ViewContactField>
          <span>{addressLink}</span>
        </ViewContactField>
      }
      {
        props.contact.professionalThirdPartyIds?.map((thirdPartyId: TAppThirdPartyId, idx: number) => {
          if (thirdPartyId.source && thirdPartyId.url && thirdPartyId.value) {
            return (
              <ViewContactField key={idx}>
                <ViewContactThirdPartyIcon alt={ThirdPartyName[thirdPartyId.source]}
                                           src={ThirdPartyIcon[thirdPartyId.source]}/>
                <ThirdPartyIdText onClick={() => openUrl(thirdPartyId.url)}>{thirdPartyId.value}</ThirdPartyIdText>
              </ViewContactField>
            );
          }
          return;
        })

      }
    </div>);
}
